import React from 'react';
import * as Backend from "../backend.js";
import * as util from "../other/util.js";
import ShipStatistics from "./ship-statistics-view.js";
import { GameData } from "../share/game-data.js";
import ShipConfig from "../share/ship-config.js";
import ShipCostFormulas from "../share/formulas/ship-cost-formulas.js";
import CompactResourcesView from "./compact-resources-view.js";

// A list with all available ship designs for the player
class ShipDesignView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this.refreshState();
    }

    refreshState() {
        let ship_design_id = this.props.params.id;
        Backend.getShipDesign(ship_design_id, (res) => {
            if (res.success) {
                this.setState({ ship_design: res.ship_design });
            } else {
                this.setState({ ship_design: null });
            }
        });
    }

    render() {
        const ship_design = this.state.ship_design;
        if (!ship_design) {
            return (<util.LoadingBar thing={ship_design} thingName="Ship design" />);
        }
        const cost = ShipCostFormulas.getShipBuildCost(ship_design.config);

        return (
            <div className="fade-in" key={Math.random()}>
                <h1>Ship Design</h1>
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "50%" }}>
                        <ShipConfigMeta shipDesign={ship_design} />
                        <ShipConfigView shipDesign={ship_design} />
                        <h4>Cost</h4>
                        <CompactResourcesView resources={cost} />
                    </div>
                    <div style={{ flex: "10%" }} />
                    <div style={{ flex: "50%" }}>
                        <ShipStatistics shipDesign={ship_design} />
                    </div>
                </div>
                <util.JsonDebug obj={ship_design} />
            </div>
        );
    }
}

class ShipConfigView extends React.Component {
    render() {
        const ship_design = this.props.shipDesign;
        const ship_config = new ShipConfig(ship_design.config);

        return (
            <div>
                <h4>Ship Config</h4>
                <table className="generic-list">
                    <tbody>
                        <tr>
                            <td>Modules</td>
                            <td>{ship_config.getRequiredModuleCount()}/{ship_config.getAvailableModuleCount()}</td>
                        </tr>
                        {
                            Object.entries(ship_design.config).map((a, idx) => <ShipTechnology key={idx} technologyId={a[0]} technologyLevel={a[1]} />)
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}

class ShipTechnology extends React.Component {
    render() {
        const technology_id = this.props.technologyId;
        const technology = GameData.TECHNOLOGY_BY_ID[technology_id];
        const technology_level = this.props.technologyLevel;

        if (technology_level > 0) {
            return (
                <tr>
                    <td>{technology.ui_name}</td>
                    <td>{technology_level}</td>
                </tr>
            )
        } else {
            return null;
        }
    }
}

class ShipConfigMeta extends React.Component {
    render() {
        const ship_design = this.props.shipDesign;
        return (<div>
            <h4>Meta</h4>
            <table className="generic-list">
                <tbody>
                    <tr>
                        <td>Name</td>
                        <td>{ship_design.name}</td>
                    </tr>
                    <tr>
                        <td>Number built</td>
                        <td>{ship_design.build_count}</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td>{ship_design.status}</td>
                    </tr>
                    <tr>
                        <td>Role</td>
                        <td>
                            <util.Tooltip tooltipStyle={{ width: "300px", marginLeft: "-120px" }} tooltip={<span>{GameData.SHIP_ROLE_BY_ID[ship_design.config.role].description}</span>}>{GameData.SHIP_ROLE_BY_ID[ship_design.config.role].ui_name}</util.Tooltip>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>)
    }
}

export default util.withParams(ShipDesignView);